import i18n from "src/i18n";

import { ROLES } from "@constants/index";


export const getAdminDashboardNavLinks = () => [
  {
    id: 1,
    label: i18n.t("overview"),
    value: "overview",
    isEnabled: true,
  },
  {
    id: 2,
    label: i18n.t("consultations"),
    value: "consultations",
    isEnabled: true,
  },
  {
    id: 3,
    label: i18n.t("labs"),
    value: "labs",
    isEnabled: true,
  },
  {
    id: 4,
    label: i18n.t("prescriptions"),
    value: "prescriptions",
    isEnabled: true,
  },
  {
    id: 5,
    label: i18n.t("certifications"),
    value: "certifications",
    isEnabled: false,
  },
  {
    id: 6,
    label: i18n.t("earnings"),
    value: "earnings",
    isEnabled: true,
  },
  {
    id: 7,
    label: i18n.t("staff"),
    value: "staff",
    isEnabled: true,
  },
  {
    id: 8,
    label: i18n.t("profile-activity-nav"),
    value: "profile-activity",
    isEnabled: true,
  },
];

export const getStaffDashboardNavLinks = (canAccessPath: (path: string) => boolean) => {
  const links = [
    {
      id: 1,
      label: i18n.t("overview"),
      value: "overview",
      isEnabled: true,
      roles: [ROLES.DOCTOR, ROLES.NURSE],
    },
    {
      id: 2,
      label: i18n.t("consultations"),
      value: "consultations",
      isEnabled: true,
      roles: [ROLES.DOCTOR, ROLES.NURSE],
    },
    {
      id: 3,
      label: i18n.t("labs"),
      value: "labs",
      isEnabled: true,
      roles: [ROLES.DOCTOR, ROLES.NURSE],
    },
    {
      id: 4,
      label: i18n.t("prescriptions"),
      value: "prescriptions",
      isEnabled: true,
      roles: [ROLES.DOCTOR],
    },
    {
      id: 5,
      label: i18n.t("earnings"),
      value: "earnings",
      isEnabled: true,
      roles: [ROLES.DOCTOR],
    },
    {
      id: 6,
      label: i18n.t("profile-activity-nav"),
      value: "profile-activity",
      isEnabled: true,
      roles: [ROLES.DOCTOR],
    },
  ];

  // Filter links based on roles
  const filteredLinks = links.filter(link => {
    return canAccessPath("dashboard/staff/" + link.value);
  });

  return filteredLinks;
};
